module.exports = __webpack_public_path__ + "img/springClamp.b406623b.png";